<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="subBlockContainer entry-loader">
  <div class="subBlockContent">
    <div class="">
        <div class="inner-subBlock-wrapper">
            <div class="page-title-wrapper">
              <div class="title blade-title">
                {{title}} - {{ subscriptionName }}
              </div>
              <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
            </div>
          </div>
    </div>
    
    <div class="inner-subBlock-content">
        
        <div class="inner-subBlock-wrapper" [hidden]="true">
            <div class="row padding-l-x20">
                <div class="col infoSection shadow-wrapper">
                    <div class="chartSection">
                        <canvas id="chartDailyTenantUsage" width="308" height="286"></canvas>
                        
                    </div>
                </div>

                <div class="col infoSection shadow-wrapper">
                    <div class="chartSection">
                        <canvas id="chartDailyTenantUsageCategory" width="308" height="286"></canvas>
                    </div>
                </div>

            </div>
      </div>
      <div class="inner-subBlock-wrapper" *ngIf="loadContent && tenantDailyResourceUsage?.length === 0">
          <div class="page-subtitle-wrapper">CURRENT RESOURCE USAGE UNBILLED - DAILY</div>
          <div class="noData-wrapper">
            <div>
              <img src="../../images/new_ui/no-subscription.png">
            </div>
            <label class="noData-label">
              We couldn't find any <br />
              records for this tenant
            </label>

          </div>
        </div>
        
        <div class="inner-subBlock-wrapper" style="margin-top: 0px;" *ngIf="tenantDailyResourceUsage?.length">
            <div class="page-subtitle-wrapper">CURRENT RESOURCE USAGE UNBILLED - DAILY</div>
            <div class="row filter-wrapper" style="margin-top: 20px;">
                <div class="col-md-3">
                  <div class="searchInputGroup">
                    <div class="searchIcon">
                      <img src="../../images/new_ui/filter.png">
                    </div>
                    <input class="searchInput" type="text" placeholder="Filter" [(ngModel)]="searchField">
                  </div>
                </div>
                <div class="col-md-3">
                    
                </div>
              </div>
              <div class="row">
                  <div class="shared-outer-wrapper">
                      <table matSort (matSortChange)="sortData($event)">
                          <thead>
                            <tr class="row order-title-wrapper">
                              <th class="col" mat-sort-header="category" style="min-width: 30%;">CATEGORY</th>
                              <th class="col" mat-sort-header="subCategory" style="min-width: 30%;">SUB CATEGORY</th>
                              <th class="col" mat-sort-header="usageStartDate">USAGE DATE</th>
                              <th class="col align-right" mat-sort-header="totalCost">TOTAL AMOUNT</th>
                            </tr>
                          </thead>
                          <tbody class="scrollable-table-body">
                             <ng-container *ngFor="let item of sortedData | TableFilterMultiple: ['category', 'subCategory', 'usageStartDate'] : searchField">
                               <tr class="row order-content-wrapper">
                                 <td class="col-md" style="min-width: 30%;">{{ item.category }}</td>
                                 <td class="col-md" style="min-width: 30%;">{{ item.subCategory }}</td>
                                 <td class="col-md">{{ item.usageStartDate }}</td>
                                 <td class="col-md align-right">{{ item.currentUsageTotal | currency:'AUD':'symbol-narrow':'.2-2' }}</td>
                               </tr>
                             </ng-container>
                          </tbody>
                      </table>
                  </div>
              </div>
        </div>

        <loading-screen [hidden]="loadContent" [isScrolled]="true" backDropWidth="1024" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)"></loading-screen>
    </div>
  </div>
</div>


<router-outlet></router-outlet>